import { render, staticRenderFns } from "./InviteUserIcon.vue?vue&type=template&id=fa72a728&scoped=true&"
import script from "./InviteUserIcon.vue?vue&type=script&lang=js&"
export * from "./InviteUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa72a728",
  null
  
)

export default component.exports